import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { IPromotionRecord } from './PromotionTypes';
import { FormatDate } from '../../utils/Tools';
import Button from '../_Core/Button';

const PromotionHistory = () => {
  const [history, setHistory] = useState<IPromotionRecord[]>([]);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = () => {
    store.server
      .getApi2<IPromotionRecord[]>('/FairPromotion/PromotionHistory')
      .then((x) => {
        if (x.Success) {
          setHistory(x.Value);
        } else {
          toast.error('Failed to load advancement history');
          console.error(x.Message);
        }
      })
      .catch((error) => {
        toast.error(`Error loading advancement history: ${error.message}`);
        console.error(`Error loading advancement history: ${error.message}`);
      });
  };

  return (
    <div>
      <div className="flex-between">
        <div>
          <h4>Advancement History</h4>
        </div>
        <div>
          <Button type="refresh" onClick={loadHistory} text="Refresh" />
        </div>
      </div>
      <div className="item-list">
        {history.map((record) => (
          <div key={record.Id} className="list-item">
            <h3>
              "{record.FairName}" to "{record.DestinationFairName}"
            </h3>
            <div>                
              {record.ProcessedAtUtc ? `Processed at: ${FormatDate(record.ProcessedAtUtc)}` : 'Processing...'}
            </div>
            <div>
              Promoted by: {record.RequestedByName} on {FormatDate(record.CreatedAtUtc)}
            </div>
            {record.ProcessedAtUtc && (
              <p>
                Success: {record.PromotedEntriesSuccess}, Failure: {record.PromotedEntriesFailure}
              </p>
            )}
            {record.ErrorMessage && (
              <p className="alert alert-danger">
                Error Processing Request...
              </p>
            )}
          </div>
        ))}
        {history.length === 0 && <p>No advancement history available.</p>}
      </div>
      {/* Add your advancement history content here */}
    </div>
  );
};

export default PromotionHistory;
